import _ from 'lodash'
import { HM_QUESTION_TYPE as QUESTION_TYPE } from '@/constant/questionnaire'

const I18N_PREFIX = 'admin.company.questionnaireManagement'

export const QUESTION_TYPE_OPTIONS = [
  { value: QUESTION_TYPE.RATING, labelI18nKey: `${I18N_PREFIX}.questionType.rating` },
  { value: QUESTION_TYPE.TEXT, labelI18nKey: `${I18N_PREFIX}.questionType.text` },
  { value: QUESTION_TYPE.SINGLE, labelI18nKey: `${I18N_PREFIX}.questionType.single` },
  { value: QUESTION_TYPE.MULTIPLE, labelI18nKey: `${I18N_PREFIX}.questionType.multiple` },
  { value: QUESTION_TYPE.DATE, labelI18nKey: `${I18N_PREFIX}.questionType.date` }
]

export function getQuestionTypeLabel (vm, type) {
  const option = _.find(QUESTION_TYPE_OPTIONS, item => item.value === type)
  return option ? vm.$t(option.labelI18nKey) : type
}

export function isOptionQuestion (type) {
  return _.includes([QUESTION_TYPE.SINGLE, QUESTION_TYPE.MULTIPLE], type)
}

export function isRatingQuestion (type) {
  return type === QUESTION_TYPE.RATING
}
